// 密码的默认展示规则（此规则已与后端约定，请勿轻易修改）
export const PasswordRule = '******'

// 分成类型
export const DivisionTypes = [
  {
    value: 1,
    text: '仅IAP'
  },
  {
    value: 2,
    text: '仅IAA'
  },
  {
    value: 3,
    text: 'IAP+IAA'
  },
]

// 短剧评级类型
export const DramaGradeTypes = [
  {
    value: 'S',
    text: 'S'
  },
  {
    value: 'A',
    text: 'A'
  },
  {
    value: 'B',
    text: 'B'
  },
]

// 短剧频道类型
export const DramaChannelTypes = [
  {
    value: 1,
    text: '男频'
  },
  {
    value: 2,
    text: '女频'
  },
]

// 客户端类型
export const ClientTypes = [
  {
    value: 1,
    text: '微小',
  },
  {
    value: 2,
    text: '抖小',
  },
  {
    value: 3,
    text: '快小',
  },
  {
    value: 4,
    text: 'H5',
  },
]

// 上架状态
export const OnShelfTypes = [
  {
    value: 1,
    text: '在架'
  },
  {
    value: 2,
    text: '下架'
  },
]

// 星图状态
export const XinTuStateTypes = [
  {
    value: 1,
    text: '投稿中'
  },
  {
    value: 2,
    text: '选稿中'
  },
  {
    value: 3,
    text: '公示中'
  },
  {
    value: 4,
    text: '奖励发放'
  },
  {
    value: 5,
    text: '计费中'
  },
  {
    value: 6,
    text: '预热中'
  },
  {
    value: 10,
    text: '已关闭'
  },
  {
    value: 11,
    text: '已取消'
  },
]
